module.exports = __webpack_public_path__ + "static/media/website.ed284c4f.svg";